import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const i18n = {
	vuei18nPlugin: new VueI18n({
		locale: 'de',
		fallbackLocale: 'en',
		messages: {}
	}),

	setLanguage() {
		const locale =
			localStorage.getItem('lang') || navigator.language.slice(0, 2)
		if (locale === 'de' || locale === 'en') {
			this.vuei18nPlugin.locale = locale
		} else {
			this.vuei18nPlugin.locale = 'en'
		}
	}
}

i18n.setLanguage()
export default i18n.vuei18nPlugin
